module.exports = __webpack_public_path__ + "static/media/gif-file.545de2c8.svg";